module.exports = __webpack_public_path__ + "static/media/golf-club.649a01d1.svg";